/**
 * EM 工作流业务数据通用ListView mixin
 *   先混入emCommonListMixin
 *   再额外提供，workflow的默认pathType
 *   及workflow的handleApprove方法和init方法
 *
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
import emCommonListMixin from "@/mixin/em/common/list";
import {mapState} from "vuex";

export default {
    mixins: [emCommonListMixin],
    computed: {
        ...mapState({
            taskListNeedRefresh: state => state.workflow.taskListNeedRefresh,
        }),
        /**
         * 路由状态
         * base.js中的save方法会自动跳转到list，那个就不带pathType参数。
         * 通过这样的设置，可以让新增记录成功后，直接跳转到待办页面,而不是查询页
         * @returns {*}
         */
        $_emWorkflowListMixin_pathType() {
            return this.$_emRouterHelperMixin_pathType ? this.$_emRouterHelperMixin_pathType : 'todo'
        },
        $_emWorkflowListMixin_queryApi() {
            return "workflow/find-by-query-form"
        }
    },
    data() {
        return {
            emWorkflowListLoading: false
        }
    },
    methods: {
        $_emWorkflowListMixin_handleApprove(businessData, path) {
            console.log("businessData:", businessData)
            //判断如果允许修改，且设置有自定义的modifyFormName(自定义工作流数据修改表单)， 就把modifyFormName（首字母大写）拼装上entity组成新的store.modelName
            //使用刚强的工作流控件，这个就不用了
            // let vuexModelName = businessData.processStatusAllowToModify && businessData.processStatusModifyFormName
            //     ? this.modelName + businessData.processStatusModifyFormName.charAt(0).toUpperCase() + businessData.processStatusModifyFormName.slice(1)
            //     : this.modelName
            let vuexModelName = this.modelName

            //设置vuex中modifyForm的entity和processBusinessData（深拷贝）
            //因为emWorkflowBusinessDataEditor中显示和修改可能用的是两个vuex模块中的内容，所以都要修改
            this.$store.commit(vuexModelName + "/setEntity", businessData)
            this.$store.commit(vuexModelName + "/setProcessBusinessData", JSON.parse(JSON.stringify(businessData)))

            //path不为空，就按path跳转，并传递本页面的pathType过去
            path ? this.$router.push({path, query: {pathType: this.$_emWorkflowListMixin_pathType}})
                //否则就按name=entityTask跳转,所以要求router命名时，要遵守这个规则
                : this.$router.push({
                    name: this.modelName + 'Task',
                    query: {pathType: this.$_emWorkflowListMixin_pathType}
                })

            // this.$router.push({
            //     name: path ? path //path不为空，就按path跳转，并传递本页面的pathType过去
            //         : this.modelName + 'Task',//否则就按name=entityTask跳转,所以要求router命名时，要遵守这个规则
            //     query: {
            //         pathType: this.$_emWorkflowListMixin_pathType,
            //         id: businessData.id
            //     }
            // })
        },
        setFilterHolder() {
            //设置workflowQueryTypeFilter
            this.$store.commit(this.modelName + "/setFilterAttribute", {
                key: "workflowQueryTypeFilter",
                newValue: this.$_emWorkflowListMixin_pathType
            })
            //设置filterHolder，让清空查询条件也清除不掉workflowQueryTypeFilter这个条件
            this.$store.commit(this.modelName + "/setFilterHolderAttribute", {
                key: "workflowQueryTypeFilter",
                newValue: this.$_emWorkflowListMixin_pathType
            })
        },
        $_emWorkflowListMixin_init() {
            this.setFilterHolder();
            //先清空查询条件和结果
            //if (this.$_emWorkflowListMixin_pathType === "list") {
            this.$store.dispatch("emBase/emBaseClearFilter", {entity: this.modelName})
            //}
            //如果是todo或wait，就自动执行查询，list也是，还有claim
            if (this.$_emWorkflowListMixin_pathType === "todo"
                || this.$_emWorkflowListMixin_pathType === "wait"
                || this.$_emWorkflowListMixin_pathType === "list"
                || this.$_emWorkflowListMixin_pathType === 'claim') {
                this.emWorkflowListLoading = true;
                this.$store.dispatch("emBase/emBaseQueryByFilter", {
                    entity: this.modelName,
                    queryApi: this.$_emWorkflowListMixin_queryApi
                }).then(() => {
                    this.$forceUpdate();
                }).finally(() => this.emWorkflowListLoading = false);
            }
        }
    },
    mounted() {
        // this.$_emCommonListMixin_needToRefresh && this.$_emWorkflowListMixin_init();
        if (this.taskListNeedRefresh) {
            console.log('need refresh')
            this.$refs['emListFilter'].doQuery();
            this.$store.commit('workflow/setTaskListNeedRefresh', false);
        } else {
            console.log('not need refresh, so init')
            this.$_emWorkflowListMixin_init();
        }
    },
    watch: {
        $_emWorkflowListMixin_pathType(val, oldVal) {
            if (val === 'list' || oldVal === 'list') {
                this.$_emWorkflowListMixin_init();
            } else {
                this.setFilterHolder();
                this.$refs['emListFilter'].doQuery();
            }
        }
    }
};
